import { BaseRequest } from 'planning-portal-library/src/lib/data/shared/base.request';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { DistributionAreaRepository } from "../../repositories";
import { DistributionArea } from '../../domain';
import { BaseResponse } from 'planning-portal-library/src/lib/data/shared/base.response';

@Injectable({ providedIn: 'root' })
export class GetDistributionAreasUsecase implements UseCase<BaseRequest<any>,DistributionArea[]> {

  constructor(private DistributionAreaRepository: DistributionAreaRepository) {
  }

  execute(distributionLaneId:any): Observable<DistributionArea[]> {
    return this.DistributionAreaRepository.getDistributionAreas(distributionLaneId);
  }

}
